import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { __API_URL__ } from "../SERVER_URL";

const fetchAvailableLanguages = async () => {
  const token = localStorage.getItem("token");
  const res = await axios.get(`${__API_URL__}/api/user/languages/`, {
    headers: { Authorization: `Token ${token}` },
  });
  return res.data.languages;
};

const useGetAvailableLanguages = ({ enabled = true } = {}) => {
  return useQuery({
    queryKey: ["available_languages"],
    queryFn: fetchAvailableLanguages,
    enabled,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
};

export default useGetAvailableLanguages;
